import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl, Validators } from '@angular/forms';

/**
 * Contains the following {FormControl}s:
 * * RequestPurpose
 */
@Component({
  selector: 'app-request-purpose-info',
  templateUrl: './request-purpose-info.component.html',
  styleUrls: ['./request-purpose-info.component.scss'],
})
export class RequestPurposeInfoComponent implements OnInit {
  @Input() controls: {
    [key: string]: AbstractControl;
  } = {};
  @Input() label = 'Purpose';

  constructor() {}

  ngOnInit(): void {}

  getFormControl(key: string): FormControl {
    return this.controls[key] as FormControl;
  }

  controlIsRequired(key: string): boolean {
    if (
      this.controls[key] &&
      this.controls[key].hasValidator(Validators.required)
    ) {
      return true;
    }

    return false;
  }
}
